// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import useAuth from 'hooks/useAuth';
import { useSelector } from 'store';

// Mục menu chỉ dành cho hạnh sinh có trong danh sách đăng ký thực tập Trung Minh.
const MUC_DANG_KY_THUC_TAP = 'hanh-sinh-dang-ky-thuc-tap';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const { user } = useAuth();
    const { phieu: phieuThucTap } = useSelector((state) => state.dangKyThucTap);
    var menuItems = menuItem(user);

    const navItems = menuItems.items.map((item) => {
        if (!item) return;

        // Không có phiếu (không thuộc danh sách, hoặc chưa tải xong) thì giấu mục đăng ký
        // thực tập: trang đó với người ngoài danh sách chỉ là một câu "không thuộc danh sách".
        if (!phieuThucTap && item.children?.some((c) => c.id === MUC_DANG_KY_THUC_TAP)) {
            item = { ...item, children: item.children.filter((c) => c.id !== MUC_DANG_KY_THUC_TAP) };
        }

        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default MenuList;
